import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { TSIconModule, TsButtonModule } from 'tsui';
import { DialogRef } from '@angular/cdk/dialog';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';

@Component({
  selector: 'app-approval-decline-modal',
  standalone: true,
  imports: [CommonModule, MatDividerModule, TsButtonModule, FormsModule, TSIconModule, TsDialogComponent],
  template: `
    <ts-dialog title="Decline notes">
      <div ts-dialog-body>
        <textarea
          class="resize-none w-full p-2 border border-black-200"
          placeholder="Add decline reason..."
          [(ngModel)]="note"
        ></textarea>
      </div>
      <div ts-dialog-actions class="ts-dialog-actions-container">
        <ts-button (click)="cancel()" variant="secondary">Cancel</ts-button>
        <ts-button (click)="decline()" variant="danger">Decline</ts-button>
      </div>
    </ts-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApprovalDeclineModalComponent {
  note: string;

  constructor(private readonly dialogRef: DialogRef<{ note: string }>) {}

  cancel(): void {
    this.dialogRef.close();
  }

  decline(): void {
    this.dialogRef.close({
      note: this.note,
    });
  }
}
